import Axios from "axios";
import { action, decorate, observable } from "mobx";
import moment from "moment";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { convertTextToID } from "../../../../utils/GlobalFunction";

export default class ManageInwardEntryStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	editValues = null;
	deleteValues = null;
	statusValues = null;
	viewValues = null;
	total = 0;
	allColumnIds = [];
	deleteConValues = null;
	isActiveFilterList = null;
	offloadValues = null;
	ManagecommonStoreObject = null;
	dropdown_inward_list = null;
	actionFilterList = [];

	constructor(ManagecommonStoreObject) {
		this.ManagecommonStoreObject = ManagecommonStoreObject;
	}

	// set form values to offloads 
	setOffLoadsValues = (data) => {
		this.offloadValues = data;
	}

	//set form values to edit
	setEditValues = (data) => {
		this.editValues = data;
	};

	// set form values to view
	setViewValues = (data) => {
		this.viewValues = data;
	};

	//set set filter values to status 
	setIsActiveFilterList = (data) => {
		this.isActiveFilterList = data;
	}

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data;
	};

	// set form values to status
	setStatusValues = (data) => {
		this.statusValues = data;
	};

	// set form values to delete Item
	setDeleteConValues = (data) => {
		this.deleteConValues = data;
	};

	setActionFilterList = (data) => {
		this.actionFilterList = data.inward_actions;
	}

	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		this.agGrid.api.setFilterModel({
			entry_date: { dateFrom: moment().format("YYYY-MM-DD"), dateTo: moment().format("YYYY-MM-DD"), type: "inRange", filterType: "date" }
		});
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource)
	};

	// change page size, default page size is ServerGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	// call api to get records
	getList = (payload) => {
		return Axios.post(`bookings/inward/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					return null;
				});
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;
		if (final_filter["status"]) {
			final_filter['status'].values = convertTextToID(final_filter['status'], this.isActiveFilterList, 'name', 'id')
		}
		if (final_filter["ia_id"]) {
			final_filter['ia_id'].values = convertTextToID(final_filter['ia_id'], this.actionFilterList, 'name', 'id')
		}
		return { final_filter, final_sort }
	}

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var payload = {
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil((params.request.startRow + 1) / (params.request.endRow - params.request.startRow))
				}
				this.getList(payload).then((data) => {
					if (data.list.total === 0) { this.agGrid.api.showNoRowsOverlay() }
					else { this.agGrid.api.hideOverlay() }
					params.successCallback(data.list.data, data.list.total)
					var allColumnIds = []
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id)
						})
					}
				})
			}
		}
	}

	// Call add api
	AddData = (formdata) => {
		return Axios.post(`bookings/inward/inward-enrty-save`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				this.setViewValues(data.view)
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// call api to get records
	ViewData = (ID) => {
		return Axios.get(`bookings/inward/details/${ID}`).then(({ data }) => {
			this.setViewValues(data.view);
			return data;
		});
	};

	// Call add api
	AddItem = (formdata) => {
		return Axios.post(`bookings/inward/add-item`, formdata)
			.then(({ data }) => {
				if (this.viewValues && this.viewValues.bk_io_inward_details) {
					let view = this.viewValues;
					// let currentCon;
					if (data?.view) {
						// let res = data?.view?.bk_io_inward_details;
						// if (res) {
						// 	currentCon = [...res, ...view.bk_io_inward_details];
						// } else {
						// 	currentCon = view.bk_io_inward_details;
						// }
						// const uniquebag = currentCon.filter((element) => {
						// 	const isDuplicate = currentCon.includes(element.item_no);
						// 	if (!isDuplicate) {
						// 		return currentCon.push(element.item_no);
						// 	}
						// 	return null
						// });
						// view.bk_io_inward_details = uniquebag;
						this.setViewValues(view)
					} else {
						this.setViewValues(view)
					}
				} else if (data?.view?.bk_io_inward_details) {
					let view = this.viewValues;
					view.bk_io_inward_details = data?.view?.bk_io_inward_details
					this.setViewValues(view)
				}
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				const { NOTIFICATION, ...fieldErrors } = data.STATUS;
				if (data && data.STATUS) {
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call delete api
	DeleteConData = (formdata) => {
		return Axios.post(`/bookings/inward/inward-enrty-delete`, formdata)
			.then(({ data }) => {
				if (this.viewValues && this.viewValues.bk_io_inward_details && this.viewValues.bk_io_inward_details.length > 0) {
					let view = this.viewValues;
					let currentCon = []
					let formValue;
					formdata.inward_detail.map((item) => { return formValue = item.id })
					currentCon = view.bk_io_inward_details.filter(item => item.id !== formValue);
					view.bk_io_inward_details = currentCon ?? [];
					this.setViewValues(view)
					// this.setEditValues(view)
				}
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return this.viewValues;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ChangeWeight = (formdata) => {
		return Axios.post(`bookings/bags/edit-weight`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	}

	getInwardList = (conditional = {}) => {
		return Axios.post(`admin/inward-actions/lov`, conditional)
			.then(({ data }) => {
				this.dropdown_inward_list = data.inward_actions;
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	refreshList = () => {
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	}
}

decorate(ManageInwardEntryStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	editValues: observable,
	deleteValues: observable,
	statusValues: observable,
	deleteConValues: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setStatusValues: action,
	setPageSize: action,
	setDeleteValues: action,
	setDeleteConValues: action,
	getList: action,
	changeFilterAndSort: action,
	onFilterChanged: action,
	createDatasource: action,
	setViewValues: action,
	viewValues: observable,
	setIsActiveFilterList: action,
	isActiveFilterList: observable,
	ChangeWeight: action,
	setOffLoadsValues: action,
	offloadValues: observable,
	getCoLoadersList: action,
	dropdown_coloaders_list: observable,
	dropdown_inward_list: observable,
	setActionFilterList: action,
	actionFilterList: observable,
	refreshList: action
});
